module.exports = __webpack_public_path__ + "static/media/plus.3650644a.svg";